import React, { useState, useEffect } from 'react';
import moment from "moment";
import { Trans } from 'react-i18next';
import { useMutation } from "@apollo/client";

import { reverseReceiveTime } from '../../../Helpers/ReceiveTimeInArray';
import { constants } from '../../../Helpers/Constants';
import { CREATE_BOOKING } from '../../../GraphQL/Mutations/bookings';
import { openPullout } from '../../../Actions/stakeholderActions';

export const CreateBookingActionButtons = ({ closePullout, legacyApiCreateBooking, bookingForm, vehicleId, profilesList, profileSelected, bookingType, settings, calendarBooking, loggedInUser, dispatch }) => {
    const [createBookingMutation, { data, loading, error }] = useMutation(CREATE_BOOKING);

    const [loadingCreate, setLoadingCreate] = useState(false);

    const getIsoFromDateTime = (date, time) => moment(`${date} ${time}`).format('YYYY-MM-DDTHH:mm:ssZ');

    const parseBookingFormInput = (bookingBody, selectedPerson) => {
        const { start_date, end_date, pick_up_time, drop_off_time, booking_type, service_usage, vehicle_usage, notes, pick_up_person } = bookingBody;

        const vehicleId = parseInt(calendarBooking.ID);
        const type = Object.keys(constants.booking_type).find(key => constants.booking_type[key] === booking_type);

        let profileId = null;
        let userId = null;

        if (selectedPerson?.user) {
            profileId = type === 'service' ? 1 : parseInt(selectedPerson?.user?.Profile_ID);
            userId = type === 'service' ? parseInt(loggedInUser.user_id) : parseInt(selectedPerson?.user?.ID);
        } else {
            profileId = type === 'service' ? 1 : parseInt(selectedPerson?.ID);
            userId = type === 'service' ? parseInt(loggedInUser.user_id) : parseInt(selectedPerson?.ID);
        }

        return {
            vehicleId,
            type,
            profileId,
            userId,
            releasedTo: pick_up_person,
            // releasingAddress: '',
            // returningAddress: '',
            scheduledReleasedAt: getIsoFromDateTime(start_date, reverseReceiveTime(pick_up_time)),
            scheduledReturnedAt: getIsoFromDateTime(end_date, reverseReceiveTime(drop_off_time)),
            serviceBookingPurpose: booking_type === constants.booking_type.service ? service_usage : undefined,
            specialRequestRemark: notes,
            status: 'booked',
            usageType: type === 'service' ? type : settings.vehicle_usage_types[vehicle_usage],
        }
    }

    // [not in use due to queue data sync implementation]
    const createBookingGraphQL = (parsedBookingInput, legacyApiCreatedBooking) => {
        const { BOOK_ID: sourceBookingId, Start_Date, Release_Time, End_Date, Return_Time } = legacyApiCreatedBooking;

        const input = {
            ...parsedBookingInput,
            sourceBookingId,

            // TODO: remove this workaround when we migrate the booking list to graphql (we'll have the correct time string)
            scheduledReleasedAt: getIsoFromDateTime(Start_Date, Release_Time),
            scheduledReturnedAt: getIsoFromDateTime(End_Date, Return_Time),
        }

        createBookingMutation({ variables: { input } }).then((response) => {

            const createdGqlBooking = response?.data.createBooking;

            const booking = {
                ...createdGqlBooking,
                ...calendarBooking,
                ...legacyApiCreatedBooking,
                extendedProps: {
                    booking: createdGqlBooking,
                    resourceId: parseInt(calendarBooking.ID)
                },
            };

            const { calendarRef, event, ...currentBooking } = booking;
            localStorage.setItem('currentBooking', JSON.stringify(currentBooking));

            // [not in use due to queue data sync implementation]
            // showStatusMsg('Booking created successfully', 'success');
            // window.location.reload();
        }).catch((error) => {
            console.error('[createBookingMutation] error: ', error);
        });
    }

	const getValidationBookingFormError = (bookingInput, bookingForm) => {
		const { profileId, userId, releasedTo, scheduledReleasedAt, scheduledReturnedAt, type, usageType, serviceBookingPurpose } = bookingInput;
        const { pick_up_time, drop_off_time } = bookingForm;

		if (type === 'service') {
			if (!serviceBookingPurpose) return 'Please fill the Service Usage field';
		} else {
			if (!profileId || !userId || !usageType) return 'Please select Profile and Vehicle Usage fields';
		}

        if (!pick_up_time) return 'Please select Pick Up Time field';
        if (!drop_off_time) return 'Please select Drop Off Time field';
        if (!scheduledReleasedAt || !scheduledReturnedAt) return 'Please fill Pick Up and Drop Off Date and Time fields';

        if (!releasedTo) return 'Please fill Pick Up Person field';

		return false;
	}

    const createBooking = () => {
        setLoadingCreate(true);

        const selectedPerson = profilesList.find((entry) => entry.ID === profileSelected);

        const bookingBody = {
            vehicle_id: parseInt(vehicleId),
            start_date: moment(bookingForm.start_date).format("YYYY-MM-DD"),
            end_date: moment(bookingForm.end_date).format("YYYY-MM-DD"),
            pick_up_time: bookingForm.pick_up_time,
            drop_off_time: bookingForm.drop_off_time,
            booking_type: bookingType === 'Service' ? constants.booking_type.service : profileSelected?.Is_User ? constants.booking_type.user : constants.booking_type.profile,
            service_usage: bookingForm.service_usage,
            vehicle_usage: bookingForm.vehicle_usage,
            notes: bookingForm.notes,
            user: profileSelected,
            pick_up_person: bookingType === 'Service' ? 'Service' : selectedPerson ? `${selectedPerson.First_Name} ${selectedPerson.Last_Name}` : ''
        };

        const parsedBookingInput = parseBookingFormInput(bookingBody, selectedPerson);

        const bookingValidationError = getValidationBookingFormError(parsedBookingInput, bookingForm);

        if (bookingValidationError) {
            showStatusMsg(bookingValidationError, 'error');
            setLoadingCreate(false);
            return;
        };

        // call legacy api sending the gql to be called after the legacy success response
        legacyApiCreateBooking(bookingBody, setLoadingCreate, (legacyApiCreatedBooking) => createBookingGraphQL(parsedBookingInput, legacyApiCreatedBooking));
    }

    const discardBooking = () => closePullout();

    return (
        <div className="booking_bottom border-top">
            <button className="button ml-16" onClick={discardBooking}>
                <Trans>Discard Booking</Trans>
            </button>
            <button className="button approve ml-16" onClick={createBooking} disabled={loadingCreate}>
                <Trans>Submit</Trans>
            </button>
        </div>
    )
}